import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=5ccc7185&scoped=true&"
import script from "./EditPage.vue?vue&type=script&lang=ts&"
export * from "./EditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc7185",
  null
  
)

export default component.exports